/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

// react
import React, { forwardRef, useMemo, useState, useEffect } from "react";
// redux
import { useDispatch } from "react-redux";
// actions
import { getListing } from "../../../../actions";
// material ui
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

const CourseSelect = forwardRef(({ value, onChange, className, handleCourseChange, index, errors }, ref) => {
  // course state
  const [courses, setCourses] = useState(null);
  const dispatch = useDispatch();
  // get courses
  const handleGetCourses = async () => {
    try {
      const response = await dispatch(getListing('courses')()).unwrap();
      setCourses(response);
    } catch (err) {
      console.log(err.message);
    }
  }

  useEffect(() => {
    handleGetCourses();
  }, []);
  // memoize courses
  const memoizedCourses = useMemo(() => courses, [courses]);
  // handle change
  const handleChange = (event) => {
    const selectedCourseId = event.target.value;
    const selectedCourse = memoizedCourses.find(course => course.id === selectedCourseId);
    handleCourseChange(index, selectedCourse ? selectedCourse.rtl : false);
    onChange(selectedCourseId);
  };
  // if no courses return null
  if (!memoizedCourses) {
    return null;
  }

  return (
    <FormControl fullWidth className={className} error={Boolean(errors)}>
      <InputLabel id="select-course">Courses</InputLabel>
      <Select
        labelId="select-course"
        id="course_id"
        value={value}
        label="Course"
        onChange={handleChange}
        ref={ref}
        classes={{ select: "flex items-center space-x-12" }}
      >
        <MenuItem value="Default" key="Default" className="space-x-12">
          <span>Default</span>
        </MenuItem>
        {memoizedCourses.map((course) => (
          <MenuItem value={course.id} key={course.id} className="space-x-12">
            <span>{course.title}</span>
          </MenuItem>
        ))}
      </Select>
      {errors && (
        <FormHelperText>{errors.message}</FormHelperText>
      )}
    </FormControl>
  );
});

export default CourseSelect;
